import React from 'react';
import useFinal from './hook';

const Final = () => {
    const { array } = useFinal();

    return (
        <React.Fragment>
            <div className="final">
                <img src="/images/final-100.jpg" alt="final"/>
            </div>
            <div className="animado animate__animated animate__pulse animate__infinite">
                <img src="/images/animado.png" alt="final"/>
            </div>
            {   
                array.map((item, key) => (
                    <React.Fragment key={key}>
                        {item}
                    </React.Fragment>
                ))
            }
        </React.Fragment>
    )
}

export default Final;